export const BRAND = {
  name: 'The Fhysique Factory',
  tagline: 'Build Your Dream Fhysique',
  trainer: 'Ramone Fearon',
  phone: '+18767713011',
  phoneDisplay: '+1 (876) 771-3011',
  whatsapp: '18767713011',
  instagram: 'fearonsfhysique',
  instagramUrl: 'https://instagram.com/fearonsfhysique',
  location: '6-8 Parkington Plaza, Maths Unlimited Building, Kingston, Jamaica',
  locationShort: 'Parkington Plaza, Kingston',
  est: '2021',
  mapsUrl: 'https://maps.google.com/?q=Parkington+Plaza+Kingston+Jamaica',
};

// ── Packages ──────────────────────────────────────────────────────────────────
export const PACKAGES = [
  {
    id: 'consultation',
    name: '1-on-1 Consultation',
    price: '$2,000',
    period: '/session',
    badge: 'START HERE',
    color: 'default',
    highlight: true,
    features: [
      '60-minute private session with Ramone',
      'Full fitness & goal assessment',
      'Personalized program recommendation',
      'Sample meal plan overview',
      'No commitment required',
      '$2,000 credited toward any monthly plan',
    ],
    cta: 'Book Now — $2,000',
  },
  {
    id: 'online',
    name: 'Online Training',
    price: '$10,000',
    period: '/month',
    badge: null,
    color: 'default',
    features: [
      'Custom meal plan for your goal',
      'Private accountability group',
      'Bi-weekly progress assessments',
      'Morning sessions (Mon, Tue, Thu, Fri — 5am)',
      'Evening sessions (Mon, Tue, Thu — 6pm)',
      '1 hour per session',
      'WhatsApp check-ins',
    ],
    cta: 'Start Online',
  },
  {
    id: 'inperson',
    name: 'In-Person Training',
    price: '$15,000',
    period: '/month',
    badge: 'MOST POPULAR',
    note: '+ $1,000 one-time access card',
    color: 'accent',
    features: [
      'Everything in Online Training',
      '5 days in-person training',
      'Access ALL sessions (morning + evening)',
      'Multiple daily time slots',
      'Parkington Plaza location',
      'Expert in-person coaching',
      'Priority booking',
    ],
    cta: 'Join In-Person',
  },
  {
    id: 'dropin',
    name: 'Drop-In Classes',
    price: '$1,500',
    period: '/class',
    badge: null,
    color: 'default',
    features: [
      'No commitment required',
      'Wed 6pm — Step Aerobics',
      'Thu 6pm — Soca Abs & Cardio',
      'Sat 7am — Powerlifting',
      'Expert instruction',
      'All fitness levels welcome',
    ],
    cta: 'Book a Class',
  },
];

export const ONLINE_SCHEDULE = [
  { day: 'Mon', times: ['5:00am', '6:00pm'] },
  { day: 'Tue', times: ['5:00am', '6:00pm'] },
  { day: 'Wed', times: [] },
  { day: 'Thu', times: ['5:00am', '6:00pm'] },
  { day: 'Fri', times: ['5:00am'] },
  { day: 'Sat', times: [] },
  { day: 'Sun', times: [] },
];

export const INPERSON_SCHEDULE = [
  { day: 'Mon', times: ['5:00am', '6:00am', '7:00am', '6:00pm', '7:15pm'] },
  { day: 'Tue', times: ['5:00am', '6:00am', '7:00am', '6:00pm', '7:15pm'] },
  { day: 'Wed', times: ['6:00am', '7:00am'] },
  { day: 'Thu', times: ['5:00am', '6:00am', '7:00am', '6:00pm', '7:15pm'] },
  { day: 'Fri', times: ['5:00am', '6:00am', '7:00am', '6:00pm'] },
];

export const DROPIN_CLASSES = [
  { day: 'Wednesday', time: '6:00pm', name: 'Step Aerobics', icon: '🏃' },
  { day: 'Thursday',  time: '6:00pm', name: 'Soca Abs & Cardio', icon: '💃' },
  { day: 'Saturday',  time: '7:00am', name: 'Powerlifting', icon: '🏋️' },
];

export const HOURS = [
  { day: 'Monday – Friday', time: '5:00am – 8:00pm' },
  { day: 'Saturday',        time: '7:00am – 12:00pm' },
  { day: 'Sunday',          time: 'Closed' },
];

export const PROFIT_SPLIT = { siteOwner: 33, gymOwner: 67 };

export const PACKAGE_VALUES = {
  consultation: 2000,
  online:       10000,
  inperson:     15000,
  dropin:       1500,
};

export const LEAD_STATUSES = ['New', 'Contacted', 'Booked', 'Paid', 'Active Member', 'Inactive'];

// Admin password validated server-side only — never in the browser.
